import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import {transfersHistory} from '../Request/Admin';

const AdminTransfers = () => {
    let mytransferHistory = transfersHistory();

    const [pendingtransfers, setPendingtransfer] = useState(0);
    const [activetransfer, setActivetransfer] = useState(0);
    const [completedtransfer, setcompletedtransfer] = useState(0);
    const getDate = (date) => new Date(date).toDateString();

    const getAmount = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting' }).format(amount);
    const setCurrenttransfer = (transfer) => {
        localStorage.setItem('adminhistorytransferSelected', JSON.stringify(transfer));
        const transferEvent = new Event('adminhistorytransferSelected');
        window.dispatchEvent(transferEvent);
    }
   
    useEffect(() => {
        document.title = 'ADMIN transferS HISTORY';
        mytransferHistory = transfersHistory();

        let pendingNum = 0;        
        let activeNum = 0;        
        let completedNum = 0;  

        mytransferHistory.forEach(transfer => {
                
                if (transfer.status === 'approved') {
                    activeNum += parseInt(transfer.amount);
                }
                if (transfer.status === 'completed') {
                    completedNum += parseInt(transfer.amount);
                }
                if (transfer.status === 'declined') {
                    completedNum += parseInt(transfer.amount);
                }
                if (transfer.status === 'pending') {
                    pendingNum += parseInt(transfer.amount);
                }
                if (transfer.status === 'waiting approval') {
                    pendingNum += parseInt(transfer.amount);
                }
            
        });
        
        setActivetransfer(activeNum);
        setcompletedtransfer(completedNum);
        setPendingtransfer(pendingNum);
        
        if(window && window.init_template){
            window.init_template();
        }  
    }, [mytransferHistory, activetransfer, completedtransfer, pendingtransfers]);

  return (
    <div id="page-content" >        
        <h2 className='text-center mb-2'>
            TRANSFER HISTORY
        </h2>
        <div className="card card-style">
            <div className="content mb-0">
                <div className="tabs tabs-pill" id="lend-customers">
                    <div className="tab-controls rounded-m p-1 overflow-visible">
                        <a className="font-13 rounded-s py-1 shadow-bg shadow-bg-s" data-bs-toggle="collapse" href="/#pending-customers" aria-expanded="true">Pending</a>
                        <a className="font-13 rounded-s py-1 shadow-bg shadow-bg-s" data-bs-toggle="collapse" href="/#active-customers" aria-expanded="false">Successful</a>
                        <a className="font-13 rounded-s py-1 shadow-bg shadow-bg-s" data-bs-toggle="collapse" href="/#completed-customers" aria-expanded="false">Completed</a>
                    </div>
                    <div className="mt-3"></div>
                    {/* <!-- Tab Bills List --> */}
                    <div className="collapse show" id="pending-customers" data-bs-parent="#lend-customers">
                        <h6 className="text-center opacity-30 pb-3">Tap an Item below for More Details </h6>
                        <div className="content mt-0 mb-0">
                            {!pendingtransfers > 0 ?
                            <div className="card card-style alert alert-dismissible border border-fade-yellow show fade p-0 mb-3">
                                <div className="content my-3">
                                    <div className="d-flex">
                                        <div className="align-self-center no-click">
                                            <i className="bi bi-exclamation-triangle font-36 color-yellow-dark d-block"></i>
                                        </div>
                                        <div className="align-self-center no-click">
                                            <p className="color-yellow-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
                                                No pending transfer records found for now
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                                mytransferHistory.map(transfer =>(
                                    (transfer.status === 'pending' || transfer.status === 'waiting approval') &&
                                    <Link key={transfer.id} onClick={()=>setCurrenttransfer(transfer)} data-bs-toggle="offcanvas" data-bs-target="#admin-transfer-history-menu"  to="#" className="d-flex pb-3">
                                        <div className="align-self-center">
                                            <span className="icon rounded-s me-2 gradient-red shadow-bg shadow-bg-xs"><i className="bi bi-droplet font-18 color-white"></i></span>
                                        </div>
                                        <div className="align-self-center ps-1">
                                            <h5 className="pt-1 mb-n1">{getAmount(transfer.amount)}</h5>
                                            <p className="mb-0 font-11 opacity-50">{getDate(transfer.created_at)}</p>
                                        </div>
                                        <div className="align-self-center ms-auto text-end">
                                            <h4 className="pt-1 mb-n1 color-red-dark">{transfer.user.name}</h4>
                                            <p className="mb-0 font-12 opacity-50">{transfer.user.email}</p>
                                        </div>
                                    </Link>
                                ))                
                                        
                            }
                        </div>                                          
                </div>

                <div className="collapse" id="active-customers" data-bs-parent="#lend-customers">
                        <h6 className="text-center opacity-30 pb-3">Tap an Item below for More Details </h6>
                        <div className="content mt-0 mb-0">
                            {!activetransfer > 0 ?
                            <div className="card card-style alert alert-dismissible border border-fade-yellow show fade p-0 mb-3">
                                <div className="content my-3">
                                    <div className="d-flex">
                                        <div className="align-self-center no-click">
                                            <i className="bi bi-exclamation-triangle font-36 color-yellow-dark d-block"></i>
                                        </div>
                                        <div className="align-self-center no-click">
                                            <p className="color-yellow-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
                                                No active transfer records found for now
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                                mytransferHistory.map(transfer =>(
                                    transfer.status === 'approved' &&
                                    <Link key={transfer.id} onClick={()=>setCurrenttransfer(transfer)} data-bs-toggle="offcanvas" data-bs-target="#admin-transfer-history-menu"  to="#" className="d-flex pb-3">
                                        <div className="align-self-center">
                                            <span className="icon rounded-s me-2 gradient-green shadow-bg shadow-bg-xs"><i className="bi bi-droplet font-18 color-white"></i></span>
                                        </div>
                                        <div className="align-self-center ps-1">
                                            <h5 className="pt-1 mb-n1">{getAmount(transfer.amount)}</h5>
                                            <p className="mb-0 font-11 opacity-50">{getDate(transfer.created_at)}</p>
                                        </div>
                                        <div className="align-self-center ms-auto text-end">
                                            <h4 className="pt-1 mb-n1 color-green-dark">{transfer.user.name}</h4>
                                            <p className="mb-0 font-12 opacity-50">{transfer.user.email}</p>
                                        </div>
                                    </Link>
                                ))                
                                        
                            }
                        </div>                                          
                </div>
                
                {/* <!-- Tab Custom Payments--> */}
                <div className="collapse" id="completed-customers" data-bs-parent="#lend-customers">
                    <h6 className="text-center opacity-30 pb-3">Tap an Item below for More Details </h6>
                    <div className="content mt-0 mb-0">
                        {!completedtransfer > 0 ?
                        <div className="card card-style alert alert-dismissible border border-fade-yellow show fade p-0 mb-3">
                            <div className="content my-3">
                                <div className="d-flex">
                                    <div className="align-self-center no-click">
                                        <i className="bi bi-exclamation-triangle font-36 color-yellow-dark d-block"></i>
                                    </div>
                                    <div className="align-self-center no-click">
                                        <p className="color-yellow-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
                                            No completed transfers record avaialable
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                            mytransferHistory.map(transfer =>(
                                (transfer.status === 'completed' || transfer.status === 'declined')  &&
                                <Link key={transfer.id} onClick={()=>setCurrenttransfer(transfer)} data-bs-toggle="offcanvas" data-bs-target="#admin-transfer-history-menu"  to="#" className="d-flex pb-3">
                                    <div className="align-self-center">
                                        <span className="icon rounded-s me-2 gradient-green shadow-bg shadow-bg-xs"><i className="bi bi-droplet font-18 color-white"></i></span>
                                    </div>
                                    <div className="align-self-center ps-1">
                                        <h5 className="pt-1 mb-n1">{getAmount(transfer.amount)}</h5>
                                        <p className="mb-0 font-11 opacity-50">{getDate(transfer.created_at)}</p>
                                    </div>
                                    <div className="align-self-center ms-auto text-end">
                                        <h4 className="pt-1 mb-n1 color-theme">{transfer.user.name}</h4>
                                        <p className="mb-0 font-12 opacity-50">{transfer.user.email}</p>
                                    </div>
                                </Link>
                            ))                
                        
                        }
                    </div>                   
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AdminTransfers